import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute component - ensures only authenticated users can access admin routes.
 * Optionally checks for specific roles.
 */
const ProtectedRoute = ({ requiredRole }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="vh-100 d-flex align-items-center justify-content-center">
                <div className="spinner-border commonColor" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/admin/login" replace />;
    }

    // Role-based check
    if (requiredRole && !user.roles?.includes(requiredRole)) {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
